module.exports = __webpack_public_path__ + "img/mask.b4d35289.svg";